import TopologyPointsService from 'js/services/api/topology/points.js'
import TopologyStopsService from 'js/services/api/topology/stops.js'
import PositionBusIconRulesService from 'js/services/position-bus-icon-rules.js'
import orderStopsByRoutePoints from 'js/lib/order-stops-by-route-points'

export default {
  data() {
    return {
      stops: [],
      sublineStops: [],
      selectedStopId: undefined,
      routeStopsRequestId: 0
    }
  },

  methods: {
    async getRouteStops(routeId) {
      this.routeStopsRequestId += 1
      const requestId = this.routeStopsRequestId
      this.stops = []

      if (routeId) {
        const pointsParams = {
          template: 'point_with_stop_reduced',
          route_id: routeId,
          stops: true,
          order_by: 'distance_to_origin',
          order_dir: 'asc',
          page: 1,
          per: 0
        }

        const stopsParams = {
          route_id: routeId,
          order_by: 'display_code',
          order_dir: 'asc',
          page: 1,
          per: 0,
          template: 'complete'
        }

        try {
          const [stopsResponse, pointsResponse] = await Promise.all([
            TopologyStopsService.index(stopsParams),
            TopologyPointsService.index({params: pointsParams, skipLoading: true})
              .catch(() => null)
          ])

          if (
            requestId !== this.routeStopsRequestId ||
            routeId !== this.selectedRouteId
          ) return

          const stops = stopsResponse.map(stop => ({
            ...stop,
            position: {
              lat: stop.lat,
              lng: stop.lng
            }
          }))

          const managedStops = this.manageStops(stops)
          this.stops = pointsResponse ?
            orderStopsByRoutePoints(managedStops, pointsResponse.data) :
            managedStops
        } catch (error) {
          if (
            requestId === this.routeStopsRequestId &&
            routeId === this.selectedRouteId
          ) {
            this.stops = []
          }
        }
      }
    },

    getSublinesStops(params = {}) {
      if (this.selectedSublineId) {
        const defaultParams = {
          template: 'reduced_with_routes',
          order_by: 'display_code',
          order_dir: 'asc',
          page: 1,
          per: 0
        }

        const attrs = {...defaultParams, ...params, skipLoading: true}
        TopologyStopsService.index(attrs).then(response => {
         const sublineStops = _.map(response, stop => ({
            id: stop.id,
            name: stop.name,
            code: stop.code,
            display_code: stop.display_code,
            position: {
              lat: stop.lat,
              lng: stop.lng
            },
            route_ids: stop.route_ids
          }))

          this.sublineStops = this.manageStops(sublineStops)
        }, () => {
          this.sublineStops = []
        })
      } else {
        this.sublineStops = []
      }
    },

    onStopAdd(marker, stop) {
      this.$set(stop, 'marker', marker)
    },

    /*
     * Abre el popup de la parada con los datos actualizados
     */
    onStopClick(
      element, positionBuses, popupTemplate, positionBusRepresentation, popUpInformationMethod
    ) {
      const target = element.target
      const currentStop = target.options.icon.options

      this.selectStopId(currentStop.stopId)

      let stopTimes = []

      // Iteramos sobre todos los buses y sacamos los tiempos de esta parada
      // MAX BUS TIME = 3000
      _.each(positionBuses, positionBus => {
        if (positionBus) {
          const stopSeconds = positionBus.times[currentStop.stopCode]
          if (stopSeconds !== 0 && typeof stopSeconds === 'number' && stopSeconds <= 3000) {
            const stopMinutes = Math.floor(stopSeconds / 60)
            stopTimes.push(positionBusRepresentation(stopMinutes, positionBus))
          }
        }
      })

      // Ordenamos los tiempos por orden creciente
      stopTimes = _.sortBy(stopTimes, ['time'])

      // Si vienen tiempos, o no hay un popup previo asociado
      // con la parada creamos uno nuevo
      if ((stopTimes.length !== 0) || (!target.popup)) {
        const popupData = popUpInformationMethod(currentStop, stopTimes)
        const popup = L.popup({closeButton: false}).setContent(popupTemplate(popupData))

        target.unbindPopup()
        target.bindPopup(popup).openPopup()
      } else {
        // Si ya hay un popup simplemente lo volvemos a abrir
        target.popup.openPopup()
      }

      this.scrollToSelectedRouteCardInSidepanel()
    },

    scrollToSelectedRouteCardInSidepanel() {
      setTimeout(() => {
        const elem = document.querySelector('.sidepanel-map__card--item.selected')
        const container = document.querySelector('.sidepanel-map__content .vb-content')

        if (elem && container) {
          container.scrollTo({top: elem.offsetTop, behavior: 'smooth'})
        }
      }, 25)
    },

    onRouteStopClick(element) {
      const popupTemplate = require('./stop-popup.pug'); // eslint-disable-line

      this.onStopClick(
        element,
        this.routeBuses,
        popupTemplate,
        this.positionBusRouteStopRepresentation,
        this.routeStopPopUpInformation
      )
    },

    positionBusRouteStopRepresentation(stopMinutes, positionBus) {
      return {
        time: stopMinutes,
        plate: positionBus.bus.plate,
        accessible: positionBus.bus.wheelchair_accessible,
        occupancy_level: positionBus.bus.occupancy_level,
        sanitized: positionBus.bus.sanitized
      }
    },

    routeStopPopUpInformation(currentStop, stopTimes) {
      const firstBusInfo = stopTimes[0] || {}
      const secondBusInfo = stopTimes[1] || {}

      return {
        stopCode: `${currentStop.stopDisplayCode}`,
        stopName: `${currentStop.stopName}`,
        firstBus: firstBusInfo.plate,
        firstTime: this.nextBusText(firstBusInfo.time),
        firstBusAccessible: PositionBusIconRulesService.isAccessible(firstBusInfo),
        firstBusHasOccupancyLevel: PositionBusIconRulesService.hasOccupancyLevel(firstBusInfo),
        firstBusOccupancyImg: PositionBusIconRulesService.occupancyImg(firstBusInfo),
        firstBusOccupancyTranslation: PositionBusIconRulesService.occupancyTranslation(
          firstBusInfo
        ),
        firstBusSanitized: PositionBusIconRulesService.isSanitized(firstBusInfo),
        secondBus: secondBusInfo.plate,
        secondTime: this.nextBusText(secondBusInfo.time),
        secondBusAccessible: PositionBusIconRulesService.isAccessible(secondBusInfo),
        secondBusHasOccupancyLevel: PositionBusIconRulesService.hasOccupancyLevel(secondBusInfo),
        secondBusOccupancyImg: PositionBusIconRulesService.occupancyImg(secondBusInfo),
        secondBusOccupancyTranslation: PositionBusIconRulesService.occupancyTranslation(
          secondBusInfo
        ),
        secondBusSanitized: PositionBusIconRulesService.isSanitized(secondBusInfo),
        accessibleTranslation: PositionBusIconRulesService.accessibleTranslation(),
        sanitizedTranslation: PositionBusIconRulesService.sanitizedTranslation(),
        arrivingText: this.$t('map.arriving')
      }
    },

    onSublineStopClick(element) {
      const popupTemplate = require('./subline-stop-popup.pug'); // eslint-disable-line

      this.onStopClick(
        element,
        this.sublineBuses,
        popupTemplate,
        this.positionBusSublineStopRepresentation,
        this.sublineStopPopUpInformation
      )
    },

    positionBusSublineStopRepresentation(stopMinutes, positionBus) {
      return {
        time: stopMinutes,
        plate: positionBus.bus.plate,
        accessible: positionBus.bus.wheelchair_accessible,
        occupancy_level: positionBus.bus.occupancy_level,
        sanitized: positionBus.bus.sanitized,
        subline_name: positionBus.subline_name,
        subline_extension: positionBus.subline_extension,
        subline_color: positionBus.subline_primary_color,
        route_origin: positionBus.route_origin,
        route_destination: positionBus.route_destination
      }
    },

    sublineStopPopUpInformation(currentStop, stopTimes) {
      const firstBusInfo = stopTimes[0] || {}
      const secondBusInfo = stopTimes[1] || {}
      const thirdBusInfo = stopTimes[2] || {}

      return {
        stopCode: `${currentStop.stopDisplayCode}`,
        stopName: `${currentStop.stopName}`,
        accessibleTranslation: PositionBusIconRulesService.accessibleTranslation(),
        sanitizedTranslation: PositionBusIconRulesService.sanitizedTranslation(),
        // Datos del primer bus
        firstBus: firstBusInfo.plate,
        firstBusPlate: this.$t(
          'stops.sidepanel.show.buses.vehicle', {plate: firstBusInfo.plate}
        ),
        firstSublineExtension: firstBusInfo.subline_extension,
        firstSublineName: firstBusInfo.subline_name,
        firstSublineBackgroundStyle: `background-color:${firstBusInfo.subline_color}`,
        firstSublineColorStyle: `color:${firstBusInfo.subline_color}`,
        firstRouteOriginDestination: this.$t(
          'stops.sidepanel.show.buses.path',
          {origin: firstBusInfo.route_origin, destination: firstBusInfo.route_destination}
        ),
        firstTime: firstBusInfo.time,
        firstTimeText: this.$t('stops.sidepanel.show.buses.time', {minutes: firstBusInfo.time}),
        firstBusAccessible: PositionBusIconRulesService.isAccessible(firstBusInfo),
        firstBusHasOccupancyLevel: PositionBusIconRulesService.hasOccupancyLevel(firstBusInfo),
        firstBusOccupancyImg: PositionBusIconRulesService.occupancyImg(firstBusInfo),
        firstBusOccupancyTranslation: PositionBusIconRulesService.occupancyTranslation(
          firstBusInfo
        ),
        firstBusSanitized: PositionBusIconRulesService.isSanitized(firstBusInfo),
        // Datos del segundo bus
        secondBus: secondBusInfo.plate,
        secondBusPlate: this.$t(
          'stops.sidepanel.show.buses.vehicle', {plate: secondBusInfo.plate}
        ),
        secondSublineExtension: secondBusInfo.subline_extension,
        secondSublineName: secondBusInfo.subline_name,
        secondSublineBackgroundStyle: `background-color:${secondBusInfo.subline_color}`,
        secondSublineColorStyle: `color:${secondBusInfo.subline_color}`,
        secondRouteOriginDestination: this.$t(
          'stops.sidepanel.show.buses.path',
          {origin: secondBusInfo.route_origin, destination: secondBusInfo.route_destination}
        ),
        secondTime: secondBusInfo.time,
        secondTimeText: this.$t('stops.sidepanel.show.buses.time', {minutes: secondBusInfo.time}),
        secondBusAccessible: PositionBusIconRulesService.isAccessible(secondBusInfo),
        secondBusHasOccupancyLevel: PositionBusIconRulesService.hasOccupancyLevel(secondBusInfo),
        secondBusOccupancyImg: PositionBusIconRulesService.occupancyImg(secondBusInfo),
        secondBusOccupancyTranslation: PositionBusIconRulesService.occupancyTranslation(
          secondBusInfo
        ),
        secondBusSanitized: PositionBusIconRulesService.isSanitized(secondBusInfo),
        // Datos del tercer bus
        thirdBus: thirdBusInfo.plate,
        thirdBusPlate: this.$t(
          'stops.sidepanel.show.buses.vehicle', {plate: thirdBusInfo.plate}
        ),
        thirdSublineExtension: thirdBusInfo.subline_extension,
        thirdSublineName: thirdBusInfo.subline_name,
        thirdSublineBackgroundStyle: `background-color:${thirdBusInfo.subline_color}`,
        thirdSublineColorStyle: `color:${thirdBusInfo.subline_color}`,
        thirdRouteOriginDestination: this.$t(
          'stops.sidepanel.show.buses.path',
          {origin: thirdBusInfo.route_origin, destination: thirdBusInfo.route_destination}
        ),
        thirdTime: thirdBusInfo.time,
        thirdTimeText: this.$t('stops.sidepanel.show.buses.time', {minutes: thirdBusInfo.time}),
        thirdBusAccessible: PositionBusIconRulesService.isAccessible(thirdBusInfo),
        thirdBusHasOccupancyLevel: PositionBusIconRulesService.hasOccupancyLevel(thirdBusInfo),
        thirdBusOccupancyImg: PositionBusIconRulesService.occupancyImg(thirdBusInfo),
        thirdBusOccupancyTranslation: PositionBusIconRulesService.occupancyTranslation(
          thirdBusInfo
        ),
        thirdBusSanitized: PositionBusIconRulesService.isSanitized(thirdBusInfo)
      }
    },

    /*
     * Devuelve el icono de cada parada
     */
    stopIcon(stop) {
      // stop.name, stop.id, stop.display_code, stop.code
      const icon = require('assets/images/map/stop-mini.png'); // eslint-disable-line

      let stopUrl = this.isValidUrl(stop.logo_url) ? stop.logo_url : icon;

      const StopIcon = L.Icon.extend({
        options: {
          iconUrl: stopUrl,
          className: 'stop-mini',
          iconAnchor: [12, 12],
          popupAnchor: [0, -12]
        }
      })

      return new StopIcon({
        stopId: stop.id,
        stopName: stop.name,
        stopDisplayCode: stop.display_code,
        stopCode: stop.code,
      })
    },

    /*
     * Devuelve el texto de la siguiente parada del popup
     */
    nextBusText(time) {
      switch (time) {
        // Llegando
        case '':
          return ['arriving', '']
        case 0:
          return ['arriving', '']
        case undefined:
          return null
        // Tiempo + minutos/segundos
        default:
          return [time, this.$t('map.time')]
      }
    },

    selectStop(stop) {
      if (this.$isPortable) this.sidePanelOpen = false

      this.$nextTick(() => {
        this.centerMap({lat: stop.position.lat, lng: stop.position.lng})
        this.onRouteStopClick(stop.marker)
      })
    },

    selectStopId(stopId) {
      this.selectedStopId = stopId
    },
    manageStops(stops) {
      let route = this.routes.find(route => route?.id === this.selectedRouteId)
      _.each(stops, stop => {
        stop.code_padded = stop.display_code.padStart(3, '0');
        stop.operator_id = route?.operator_ids?.[0]
        // Encontrar todos los operadores correspondientes y asignar sus logo_urls a la parada
        const operatorUrls = this.operators
          .filter(operator => operator.route_ids.some(id => stop.route_ids?.includes(id)))
          .map(operator => operator.img_url.url || operator.logo_url || '');

        // Asignar las URLs encontradas a la parada
        stop.logo_url = operatorUrls;
      });

      return _.sortBy(stops, 'code_padded');
    },
    isValidUrl(url) {
      if (!url) return false;
      try {
        new URL(url); // Intenta construir una URL
        return true; // Si se construye, es válida
      } catch (e) {
        return false; // Si falla, no es válida
      }
    }
  }
}
